import type { RequestConfig } from '@patsnap/common-ps-http';
import type psHttp from '@patsnap/common-ps-http'
import type { ErrorHandlerService } from './error-handler-service'
import { BaseHttpService } from './base-http-service'
import type { ICoreDataWrapper } from './exception';
import { ExceptionFactory, HttpSuccessException, HttpFailException, isAxiosError } from './exception'
import { currentClientUUID } from './current-client-uuid';

export const HttpAnalyticsException = ExceptionFactory('$$AnalyticsHttp')

export class PaperHttp extends BaseHttpService {
    constructor(
        public httpClient: typeof psHttp,
        private errorHandlerService: ErrorHandlerService
    ) {
        super(errorHandlerService)
        this.configErrorHandler()
    }

    private configErrorHandler() {
        this.errorHandlerService.addHandler(async error => {
            if (HttpSuccessException.is(error)) {
                this._errorDisplayProxy({
                    code: `${error.data.error_code}`,
                })
                return true
            }
            if (!HttpFailException.is(error)) {
                return false
            }
            const httpFailExceptionData = error.response?.data
            if (!httpFailExceptionData) {
                return false
            }
            this._errorDisplayProxy({
                code: `${httpFailExceptionData.numeric_error_code}`,
                message: httpFailExceptionData.error_message,
            })
            return true
        })
    }

    request<T = any>(config: RequestConfig): Promise<T> {
        config.headers = {
            'X-Device-ID': currentClientUUID(),
            'X-Api-Version': '2.0',
        }
        return this.httpClient<T>(config).then(
            res => {
                const data = res.data as any as ICoreDataWrapper<any>
                if (data.status === false) {
                    throw HttpSuccessException.mark(res as any)
                }
                return res.data
            },
            error => {
                if (!isAxiosError(error)) {
                    throw error
                }
                error = HttpFailException.mark(error as any)
                throw error
            })
    }
}
